import { SvgIcon, SvgIconProps } from "@mui/material";
import { FunctionComponent } from "react";

export const CheckDoubleIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6875 7.71875C6.3125 8.125 5.65625 8.125 5.28125 7.71875L2.78125 5.21875C2.375 4.84375 2.375 4.1875 2.78125 3.8125C3.15625 3.40625 3.8125 3.40625 4.1875 3.8125L5.96875 5.59375L10.2812 1.3125C10.6562 0.90625 11.3125 0.90625 11.6875 1.3125C12.0938 1.6875 12.0938 2.34375 11.6875 2.71875L6.6875 7.71875ZM6.6875 14.7188C6.3125 15.125 5.65625 15.125 5.28125 14.7188L1.28125 10.7188C0.875 10.3438 0.875 9.6875 1.28125 9.3125C1.65625 8.90625 2.3125 8.90625 2.6875 9.3125L5.96875 12.5938L13.2812 5.3125C13.6562 4.90625 14.3125 4.90625 14.6875 5.3125C15.0938 5.6875 15.0938 6.34375 14.6875 6.71875L6.6875 14.7188Z"
        fill="url(#paint0_linear_4752_31304)"
      />
      <path
        d="M6.6875 7.71875C6.3125 8.125 5.65625 8.125 5.28125 7.71875L2.78125 5.21875C2.375 4.84375 2.375 4.1875 2.78125 3.8125C3.15625 3.40625 3.8125 3.40625 4.1875 3.8125L5.96875 5.59375L10.2812 1.3125C10.6562 0.90625 11.3125 0.90625 11.6875 1.3125C12.0938 1.6875 12.0938 2.34375 11.6875 2.71875L6.6875 7.71875ZM6.6875 14.7188C6.3125 15.125 5.65625 15.125 5.28125 14.7188L1.28125 10.7188C0.875 10.3438 0.875 9.6875 1.28125 9.3125C1.65625 8.90625 2.3125 8.90625 2.6875 9.3125L5.96875 12.5938L13.2812 5.3125C13.6562 4.90625 14.3125 4.90625 14.6875 5.3125C15.0938 5.6875 15.0938 6.34375 14.6875 6.71875L6.6875 14.7188Z"
        fill="white"
        fillOpacity="0.3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4752_31304"
          x1="-2"
          y1="12.375"
          x2="16.2762"
          y2="15.3402"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.261406" stopColor="#6834FB" />
          <stop offset="1" stopColor="#FF45EC" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
